import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import User from './User';
import { initialUserManagerState, initialUnitManagerState } from '../../reducers/initialState';
import { getUserManager, getUnitManager, getUserProfileWidget } from '../../selectors/index';
import { postUserThunk, describeUserThunk, setSelectedUserThunk } from '../../actions/userManager';
import { getUnitsThunk, setCurrentPage, setPageFilter } from '../../actions/unitManager';

const mapStateToProps = (state, props) => {
  return {
    userManager: getUserManager(state) || {
        ...initialUserManagerState.userManager,
        units: [],
        profiles: []
      },
    unitManager: getUnitManager(state) || {
      ...initialUnitManagerState.unitManager
    },
    userProfileWidgets: getUserProfileWidget(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      saveUser: (user, widgetCode) => postUserThunk(user, widgetCode),
      describeUser: (userId, widgetCode) => describeUserThunk(userId, widgetCode),
      getUnits: (limit, filter, orgId, widgetCode) => getUnitsThunk(limit, filter, orgId, widgetCode),
      setCurrentPage: currentPage => setCurrentPage(currentPage),
      setPageFilter: filter => setPageFilter(filter),
      setSelectedUser: user => setSelectedUserThunk(user)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(User);
